import React from 'react';

import './NewFundSearch.scss';

const NewFundSearchSuggestionNotes = ({ fund, fundType, scsTier }) => {
  return (
    <div className="new-fund-search-suggestion-note">

    {/* {fund.notes[FundNoteAdd.OWNED_NEW] && (*/}
    {/*    <div className="new-fund-search-note-style">*/}
    {/*      You have already added this {fundType}.*/}
    {/*    </div>*/}
    {/*)}*/}

     {/*{fund.notes[FundNoteAdd.RETIREMENT_INCOME_FOR_IRA] && (*/}
     {/*   <div className="new-fund-search-note-style">*/}
     {/*     $25,000 minimum investment.*/}
     {/*   </div>*/}
     {/* )}*/}

     {/* {fund.notes[FundNoteAdd.RETIREMENT_INCOME_FOR_NON_IRA] && (*/}
     {/*   <div className="new-fund-search-note-style">*/}
     {/*     <div className="new-fund-search-note-style-min">*/}
     {/*       $25,000 minimum investment.*/}
     {/*     </div>*/}
     {/*     All dividends from the Retirement Income 2020 fund will be distributed*/}
     {/*     and deposited to your most recently added bank on file. Your bank*/}
     {/*     selection can be changed later in your account settings. If you do not*/}
     {/*     have a bank of file, dividends will be distributed by check to address*/}
     {/*     on record.*/}
     {/*   </div>*/}
     {/* )}*/}

      {fund.summit && (
        <div className="new-fund-search-note-style">
          $25,000 minimum investment.
        </div>
      )}

      {/*{(fund.notes[FundNoteBuy.MONEY_MARKET_EVENT_FEE_ACTIVE] ||*/}
      {/*    fund.notes[FundNoteBuy.MONEY_MARKET_EVENT_FEE_REMOVED] ||*/}
      {/*    fund.notes[FundNoteBuy.MONEY_MARKET_EVENT_GATE_ACTIVE] ||*/}
      {/*    fund.notes[FundNoteBuy.MONEY_MARKET_EVENT_GATE_REMOVED]) &&*/}
      {/*  (*/}
      {/*    <div*/}
      {/*      className="new-fund-search-note-style"*/}
      {/*      dangerouslySetInnerHTML={{*/}
      {/*        __html: fund.moneyMarketReformMessage,*/}
      {/*      }}*/}
      {/*    />*/}
      {/*  )}*/}
    </div>
  );
};
export default NewFundSearchSuggestionNotes;
